import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { MasterPartialState } from './master.reducer';
import { masterQuery } from './master.selectors';
import {
  ClearStore,
  CreateAirline,
  CreateAirportCode,
  CreateCarrierCode,
  CreateConsignee,
  CreateDeliveryAgent,
  CreateDestinationAirport,
  CreateNotify,
  CreateShipper,
  DeleteEntity,
  LoadAirline,
  LoadAirportCode,
  LoadCarrierCode,
  LoadConsignee,
  LoadDeliveryAgent,
  LoadDestinationAirport,
  LoadMaster,
  LoadNotify,
  LoadShipper,
  UpdateConsignee,
  UpdateDeliveryAgent,
  UpdateNotify,
  UpdateShipper,
} from './master.actions';

@Injectable()
export class MasterFacade {
  loaded$ = this.store.pipe(select(masterQuery.getLoaded));
  loading$ = this.store.pipe(select(masterQuery.getLoading));
  entityDeleteLoading$ = this.store.pipe(
    select(masterQuery.getEntityDeleteLoading)
  );
  allMaster$ = this.store.pipe(select(masterQuery.getAllMaster));
  selectedMaster$ = this.store.pipe(select(masterQuery.getSelectedMaster));
  getAllShipper$ = this.store.pipe(select(masterQuery.getAllShipper));
  getAllConsignee$ = this.store.pipe(select(masterQuery.getAllConsignee));
  getAllNotify$ = this.store.pipe(select(masterQuery.getAllNotify));
  getAllDeliveryAgent$ = this.store.pipe(
    select(masterQuery.getAllDeliveryAgent)
  );
  getAllAirportCode$ = this.store.pipe(select(masterQuery.getAllAirportCode));
  getAllCarrierCode$ = this.store.pipe(select(masterQuery.getAllCarrierCode));
  getAllDestinationAirport$ = this.store.pipe(
    select(masterQuery.getAllDestinationAirport)
  );
  getAllAirline$ = this.store.pipe(select(masterQuery.getAllAirline));

  constructor(private store: Store<MasterPartialState>) {}

  loadAll() {
    this.store.dispatch(new LoadMaster());
  }
  createShipper(data) {
    this.store.dispatch(new CreateShipper(data));
  }
  loadAllShipper() {
    this.store.dispatch(new LoadShipper());
  }
  updateShipper(data, id) {
    this.store.dispatch(new UpdateShipper(data, id));
  }
  createConsignee(data) {
    this.store.dispatch(new CreateConsignee(data));
  }
  loadAllConsignee() {
    this.store.dispatch(new LoadConsignee());
  }
  updateConsignee(data, id) {
    this.store.dispatch(new UpdateConsignee(data, id));
  }
  createNotify(data) {
    this.store.dispatch(new CreateNotify(data));
  }
  loadAllNotify() {
    this.store.dispatch(new LoadNotify());
  }
  updateNotify(data, id) {
    this.store.dispatch(new UpdateNotify(data, id));
  }
  createDeliveryAgent(data) {
    this.store.dispatch(new CreateDeliveryAgent(data));
  }
  loadAllDeliveryAgent() {
    this.store.dispatch(new LoadDeliveryAgent());
  }
  updateDeliveryAgent(data, id) {
    this.store.dispatch(new UpdateDeliveryAgent(data, id));
  }
  createAirportCode(code) {
    this.store.dispatch(new CreateAirportCode(code));
  }
  loadAllAirportCode() {
    this.store.dispatch(new LoadAirportCode());
  }
  createCarrierCode(code) {
    this.store.dispatch(new CreateCarrierCode(code));
  }
  loadAllCarrierCode() {
    this.store.dispatch(new LoadCarrierCode());
  }
  createDestinationAirport(name) {
    this.store.dispatch(new CreateDestinationAirport(name));
  }
  loadAllDestinationAirport() {
    this.store.dispatch(new LoadDestinationAirport());
  }
  createAirline(name, key) {
    this.store.dispatch(new CreateAirline(name, key));
  }
  loadAllAirline() {
    this.store.dispatch(new LoadAirline());
  }
  deleteEntity(entityName: string, id: string) {
    this.store.dispatch(new DeleteEntity(entityName, id));
  }
  clearStore() {
    this.store.dispatch(new ClearStore());
  }
}
